import { render, staticRenderFns } from "./modalRechazarPedido.vue?vue&type=template&id=26e0bae5&scoped=true&"
import script from "./modalRechazarPedido.vue?vue&type=script&lang=js&"
export * from "./modalRechazarPedido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e0bae5",
  null
  
)

export default component.exports